// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.InsuredPersons-module__iconContract--B041d>svg {
    color: #6F879C;
}

.InsuredPersons-module__btnNavigation--RSj2o {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 40px;
}
.InsuredPersons-module__updateBtnBox--jKLE1 {
    display: flex;
    justify-content: center;
    margin-top: 30px;
}
.InsuredPersons-module__errorText--bHH6t {
    margin-top: 16px;
    color: red;
    font-size: 20px;
    text-align: center;
}

.InsuredPersons-module__btnContainer--NnATE {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/insured-persons/InsuredPersons.module.css"],"names":[],"mappings":";AACA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,UAAU;IACV,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB","sourcesContent":["\r\n.iconContract>svg {\r\n    color: #6F879C;\r\n}\r\n\r\n.btnNavigation {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    align-items: center;\r\n    gap: 40px;\r\n}\r\n.updateBtnBox {\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-top: 30px;\r\n}\r\n.errorText {\r\n    margin-top: 16px;\r\n    color: red;\r\n    font-size: 20px;\r\n    text-align: center;\r\n}\r\n\r\n.btnContainer {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"iconContract": `InsuredPersons-module__iconContract--B041d`,
	"btnNavigation": `InsuredPersons-module__btnNavigation--RSj2o`,
	"updateBtnBox": `InsuredPersons-module__updateBtnBox--jKLE1`,
	"errorText": `InsuredPersons-module__errorText--bHH6t`,
	"btnContainer": `InsuredPersons-module__btnContainer--NnATE`
};
export default ___CSS_LOADER_EXPORT___;
